import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconCard = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path fillRule="evenodd" d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2m0 14H4v-6h16zm0-10H4V6h16z" />
  </SvgIcon>
);

export default IconCard;



// WEBPACK FOOTER //
// ./src/components/icons/IconCard.js